import { Box } from '@nimbus-ds/components';
import OrderInvoiceResponseDto from '@tiendanube/common/src/domains/orders/commons/OrderInvoiceResponseDto';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import InvoiceSection from '../InvoiceSection';
import OptionInvoicePopover from '../OptionInvoicePopover';

interface InvoicesProps {
  readonly invoices: OrderInvoiceResponseDto[];
  readonly t: ReturnType<typeof useTranslationOrders>;
}

function Invoices({ invoices, t }: InvoicesProps) {
  if (!invoices?.length) return null;

  return (
    <Box>
      {invoices.map((invoice) => {
        const {
          id,
          key: keyName,
          xml_url,
          pdf_url,
          last_correction_event,
          cancellation_event,
        } = invoice;

        const isCancelledSuccessfully =
          !!cancellation_event && !cancellation_event.error_message;

        return (
          <Box key={id}>
            <InvoiceSection
              title={t('cardInvoice.invoice.succes', { key: keyName })}
              xmlUrl={xml_url}
              pdfUrl={isCancelledSuccessfully ? undefined : pdf_url}
              t={t}
            />

            {!!last_correction_event?.event_type && (
              <InvoiceSection
                title={t('cardInvoice.invoice.edit')}
                errorTitle={t('cardInvoice.alert.edit.title')}
                xmlUrl={last_correction_event?.xml_url ?? undefined}
                pdfUrl={last_correction_event?.pdf_url ?? undefined}
                errorMessage={last_correction_event?.error_message}
                t={t}
              />
            )}

            {!!cancellation_event?.event_type && (
              <InvoiceSection
                title={t('cardInvoice.invoice.cancel')}
                errorTitle={t('cardInvoice.alert.cancel.title')}
                xmlUrl={cancellation_event?.xml_url ?? undefined}
                pdfUrl={cancellation_event?.pdf_url ?? undefined}
                errorMessage={cancellation_event?.error_message}
                t={t}
              />
            )}

            {!isCancelledSuccessfully && (
              <OptionInvoicePopover invoice={invoice} t={t} />
            )}
          </Box>
        );
      })}
    </Box>
  );
}

export default Invoices;
